import { Dialog, Button } from '@/components/uikit';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { ReactComponent as NotFoundSvg } from '@/assets/images/not_found.svg';
import React from 'react';
import { useTranslate } from '@/locale';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}
const NotFoundDialog = ({ isOpen, onClose }: Props) => {
  const { translate } = useTranslate();
  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={isOpen}
      PaperProps={{
        style: { borderRadius: 12 },
      }}
    >
      <MuiDialogContent style={{ padding: 0 }}>
        <div style={{ textAlign: 'center', margin: 16 }}>
          <NotFoundSvg style={{ width: '153px' }} />
          <p style={{ fontSize: '18px', fontWeight: 500, marginBottom: 0 }}>
            {translate('accountNotFound')}
          </p>
          <p style={{ color: '#363655', marginTop: 7 }}>
            {translate('accountNotFoundCaption')}
          </p>
        </div>
      </MuiDialogContent>
      <MuiDialogActions style={{ justifyContent: 'center', marginBottom: 12 }}>
        <Button
          onClick={onClose}
          style={{
            margin: 0,
            borderRadius: '24px',
            padding: '10px',
            width: '100%',
          }}
        >
          {translate('back')}
        </Button>
      </MuiDialogActions>
    </Dialog>
  );
};

export default NotFoundDialog;
